import { useSearchParams, Link } from 'react-router-dom';
import { AlertCircle } from 'lucide-react';
import SEOHead from '../components/SEOHead';
import { PAGE_SEO } from '../seo';

export default function SetupError() {
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error') || 'An unknown error occurred';

  const message = searchParams.get('message');

  const errorMessages: Record<string, string> = {
    access_denied: 'You denied access to your Slack workspace.',
    tenant_not_found: 'The setup session was not found. Please start over from the AWS Marketplace.',
    oauth_request_failed: 'Failed to connect to Slack. Please try again.',
    internal_error: 'An internal error occurred. Please try again later.',
    salesforce_oauth_failed: message || 'Salesforce authorization failed. Please try again.',
    hubspot_oauth_failed: message || 'HubSpot authorization failed. Please try again.',
    token_exchange_failed: message || 'Failed to complete authorization. Please check your app credentials.',
    invalid_oauth_state: 'Authorization session expired. Please try again.',
    missing_credentials: 'App credentials not found. Please restart the setup process.',
    callback_failed: message || 'Authorization failed unexpectedly. Please try again.',
    missing_params: 'Missing authorization parameters. Please try again.',
  };

  const friendlyMessage = errorMessages[error] || error;

  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <SEOHead page={PAGE_SEO.setup} />
      <div className="max-w-md w-full animate-slideUp">
        <div className="bg-white rounded-2xl shadow-rhythmic-xl p-8 text-center">
          <div className="w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <AlertCircle className="w-8 h-8 text-red-500" />
          </div>

          <h1 className="text-2xl font-display font-bold text-pb-gray-800 mb-2">
            Setup Error
          </h1>
          <p className="text-pb-gray-600 mb-8">{friendlyMessage}</p>

          <Link
            to="/"
            className="inline-flex items-center px-6 py-3 bg-pb-orange text-white rounded-lg font-semibold hover:bg-pb-orange-dark hover:shadow-lg transition-all"
          >
            Return Home
          </Link>
        </div>
      </div>
    </div>
  );
}
